 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","articlesmenu":"articlesmenu","labs":"labs","portfoliomenu":"portfoliomenu","projects":"projects","uiux":"uiux","videos":"videos","articles-list":"articles-list","carousel-guide":"carousel-guide","china-digital-overview":"china-digital-overview","crypto-trading-intro-guide":"crypto-trading-intro-guide","half-marathon-face-recognition":"half-marathon-face-recognition","instagram-codes-qr-ar-codes":"instagram-codes-qr-ar-codes","iphone-replaces-wallet":"iphone-replaces-wallet","mac-tv-spotify-newsfeed":"mac-tv-spotify-newsfeed","running-tech-teams":"running-tech-teams","shanghaiC-cabride":"shanghaiC-cabride","smartcity-helsinki":"smartcity-helsinki","adidas-schneller-ins-trikot":"adidas-schneller-ins-trikot","asos-urban-tour":"asos-urban-tour","cadbury-youyube-dance-off":"cadbury-youyube-dance-off","coke-zero-trust-your-buds":"coke-zero-trust-your-buds","copp-sus-makeover":"copp-sus-makeover","ford-autoshows":"ford-autoshows","galaxy-idd":"galaxy-idd","hkwd":"hkwd","lincoln-virtual-car-config":"lincoln-virtual-car-config","london-work-campaign-ar":"london-work-campaign-ar","mount-franklin-well-of-positivity":"mount-franklin-well-of-positivity","nike-nba-connected-jersey":"nike-nba-connected-jersey","nike-wechat-campaigns":"nike-wechat-campaigns","overview":"overview","pacific-place-idd":"pacific-place-idd","philips-obsessed-with-sound":"philips-obsessed-with-sound","sncf-les-petits-services":"sncf-les-petits-services","triumph-you-are-wonderful":"triumph-you-are-wonderful"}[chunkId]||chunkId) + "." + {"about":"0020968f","articlesmenu":"64455749","labs":"0fd10153","portfoliomenu":"b54c4b54","projects":"a715de17","uiux":"40ee699f","videos":"7851ab8a","articles-list":"74097eda","carousel-guide":"a18aa2a5","china-digital-overview":"588dfd2e","crypto-trading-intro-guide":"c696f0a5","half-marathon-face-recognition":"dfffb81b","instagram-codes-qr-ar-codes":"418b3c8e","iphone-replaces-wallet":"da81aebd","mac-tv-spotify-newsfeed":"fe9c9dd0","running-tech-teams":"a7ab21fd","shanghaiC-cabride":"1013baaa","smartcity-helsinki":"2c7e597e","adidas-schneller-ins-trikot":"75da85ca","asos-urban-tour":"77eba68b","cadbury-youyube-dance-off":"33174e4f","coke-zero-trust-your-buds":"e11cfdd1","copp-sus-makeover":"04cfd57f","ford-autoshows":"ce397b5b","galaxy-idd":"0e49e7bb","hkwd":"39f79301","lincoln-virtual-car-config":"0cf4acb2","london-work-campaign-ar":"f532cdc5","mount-franklin-well-of-positivity":"6d048291","nike-nba-connected-jersey":"52e815a9","nike-wechat-campaigns":"842bc081","overview":"1b0f23fc","pacific-place-idd":"3a6baec8","philips-obsessed-with-sound":"86fed8b7","sncf-les-petits-services":"3faf6d0e","triumph-you-are-wonderful":"3c5603fe"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"articlesmenu":1,"labs":1,"portfoliomenu":1,"projects":1,"uiux":1,"videos":1,"carousel-guide":1,"crypto-trading-intro-guide":1,"half-marathon-face-recognition":1,"instagram-codes-qr-ar-codes":1,"iphone-replaces-wallet":1,"running-tech-teams":1,"shanghaiC-cabride":1,"smartcity-helsinki":1,"adidas-schneller-ins-trikot":1,"asos-urban-tour":1,"cadbury-youyube-dance-off":1,"coke-zero-trust-your-buds":1,"copp-sus-makeover":1,"hkwd":1,"mount-franklin-well-of-positivity":1,"nike-wechat-campaigns":1,"pacific-place-idd":1,"philips-obsessed-with-sound":1,"sncf-les-petits-services":1,"triumph-you-are-wonderful":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","articlesmenu":"articlesmenu","labs":"labs","portfoliomenu":"portfoliomenu","projects":"projects","uiux":"uiux","videos":"videos","articles-list":"articles-list","carousel-guide":"carousel-guide","china-digital-overview":"china-digital-overview","crypto-trading-intro-guide":"crypto-trading-intro-guide","half-marathon-face-recognition":"half-marathon-face-recognition","instagram-codes-qr-ar-codes":"instagram-codes-qr-ar-codes","iphone-replaces-wallet":"iphone-replaces-wallet","mac-tv-spotify-newsfeed":"mac-tv-spotify-newsfeed","running-tech-teams":"running-tech-teams","shanghaiC-cabride":"shanghaiC-cabride","smartcity-helsinki":"smartcity-helsinki","adidas-schneller-ins-trikot":"adidas-schneller-ins-trikot","asos-urban-tour":"asos-urban-tour","cadbury-youyube-dance-off":"cadbury-youyube-dance-off","coke-zero-trust-your-buds":"coke-zero-trust-your-buds","copp-sus-makeover":"copp-sus-makeover","ford-autoshows":"ford-autoshows","galaxy-idd":"galaxy-idd","hkwd":"hkwd","lincoln-virtual-car-config":"lincoln-virtual-car-config","london-work-campaign-ar":"london-work-campaign-ar","mount-franklin-well-of-positivity":"mount-franklin-well-of-positivity","nike-nba-connected-jersey":"nike-nba-connected-jersey","nike-wechat-campaigns":"nike-wechat-campaigns","overview":"overview","pacific-place-idd":"pacific-place-idd","philips-obsessed-with-sound":"philips-obsessed-with-sound","sncf-les-petits-services":"sncf-les-petits-services","triumph-you-are-wonderful":"triumph-you-are-wonderful"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","articlesmenu":"89615901","labs":"5b7c761d","portfoliomenu":"393203be","projects":"bb0671c9","uiux":"152b3e21","videos":"39cd5083","articles-list":"31d6cfe0","carousel-guide":"389cc066","china-digital-overview":"31d6cfe0","crypto-trading-intro-guide":"f502661e","half-marathon-face-recognition":"d0aab407","instagram-codes-qr-ar-codes":"7a08640c","iphone-replaces-wallet":"bc5d8cee","mac-tv-spotify-newsfeed":"31d6cfe0","running-tech-teams":"28a0a30a","shanghaiC-cabride":"7050a78d","smartcity-helsinki":"aee3330b","adidas-schneller-ins-trikot":"73ea8ec0","asos-urban-tour":"2b128b5f","cadbury-youyube-dance-off":"c5111e20","coke-zero-trust-your-buds":"0e9ba048","copp-sus-makeover":"891b5b85","ford-autoshows":"31d6cfe0","galaxy-idd":"31d6cfe0","hkwd":"19f2e69d","lincoln-virtual-car-config":"31d6cfe0","london-work-campaign-ar":"31d6cfe0","mount-franklin-well-of-positivity":"43d74b92","nike-nba-connected-jersey":"31d6cfe0","nike-wechat-campaigns":"9cf5c93d","overview":"31d6cfe0","pacific-place-idd":"9b09824f","philips-obsessed-with-sound":"b9e6f2ea","sncf-les-petits-services":"e89500ad","triumph-you-are-wonderful":"76bfebcf"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
